import React, { PureComponent } from 'react'
import withRouter from '@ycos/nextjs/src/withRouter'
import BaseLayout from '@ycos/nextjs/src/BaseLayout'
import getConfig from 'next/config'
import Helmet from 'react-helmet'
import trackPageView, { getAnalyticsData } from '../utils/StaticPageAnalytics'
import pushDataToLiveChat from '../utils/LiveChat'
import { getStaticPageLdJson } from 'utils/GetLdJson'

const AppLayoutTracking = ({ theme, themeRtl, themeKr, themeJp }) => {
  const ltrLayout = BaseLayout(theme)
  const rtlLayout = themeRtl && BaseLayout(themeRtl)
  const krLayout = themeKr && BaseLayout(themeKr)
  const jpLayout = themeJp && BaseLayout(themeJp)

  class BaseLayoutTracking extends PureComponent {
    componentDidMount() {
      const { pageKey, tags, locale, nativeapp } = this.props
      // stick trackPageView at the end of the event loop queue to solve race condition with site-furniture script
      setTimeout(() => trackPageView(pageKey, tags, locale, nativeapp), 0)
      pushDataToLiveChat(getAnalyticsData(pageKey), locale)
    }
    render() {
      let Layout = ltrLayout

      switch (this.props.locale.language) {
        case 'ar':
          if (rtlLayout) Layout = rtlLayout
          break
        case 'ko':
          if (krLayout) Layout = krLayout
          break
        case 'ja':
          if (jpLayout) Layout = jpLayout
          break
        default:
          break
      }

      const { router, children = [] } = this.props
      const config = getConfig().publicRuntimeConfig
      const { isJsonMarkupOn, seoConfig } = config
      const pageProps = children[0]?.props
      const LdJson = JSON.stringify(getStaticPageLdJson(router, pageProps, seoConfig))
      return (
        <>
          {isJsonMarkupOn && (
            <Helmet>
              <script type="application/ld+json" key="breadcrumb-list-jsonld">
                {LdJson}
              </script>
            </Helmet>
          )}
          <Layout>{this.props.children}</Layout>
        </>
      )
    }
  }
  return withRouter(BaseLayoutTracking)
}

export default AppLayoutTracking
